<template>
  <img src="/jilly.png" class="jilly"/>
</template>

<script>
export default {
  name: "IceCream",
};
</script>
